import {ComponentFactoryResolver, Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ExgWidgetService {
  public Components: Array<any> = [];

  constructor(private resolver: ComponentFactoryResolver) {
  }

  public GetFactory(ComponentName: string): any {
    // @ts-ignore
    return this.resolver.resolveComponentFactory(this.Components.find(obj => obj.name === ComponentName));
  }
}
